module.exports = __webpack_public_path__ + "media/images/logo-icon-red-e197d54d8b34d9f705e516b3d4a655fc.png";